import { useQuery } from '@tanstack/react-query';
import { organizationService } from '@syscolect/domain';
import { useCurrentUser } from './useCurrentUser.js';
import { useDispatchHookEvent } from '@rammetec/core';
/**
 * Custom hook to get the full data for all valid organizations a user belongs to.
 * Uses organizationService.getValidOrganizations which already filters by inactivationDate.
 *
 * Hook that fetches all valid organizations the current user belongs to.
 */
export const useUserOrganizations = () => {
    const { currentUserData } = useCurrentUser();
    const { data: userOrganizations, isLoading, error } = useQuery({
        queryKey: ['validOrganizations', currentUserData?.id],
        queryFn: () => {
            if (!currentUserData?.id) {
                return [];
            }
            return organizationService.getValidOrganizations(currentUserData.id);
        },
        enabled: !!currentUserData?.id,
    });
    useDispatchHookEvent('useUserOrganizations', {
        userOrganizations,
        isLoading,
        error,
    });
    return {
        userOrganizations: userOrganizations || [],
        isLoading,
        error,
    };
};
//# sourceMappingURL=useUserOrganizations.js.map